import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import viewMixin from '../../../components/core/consumers/viewMixin';
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { mapState } from 'vuex';
var emptyModel = {
  chain: [],
  trigger: {}
};
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewConnectorsConsumersChains',
  mixins: [viewMixin, userItemsPerListMixin],
  data: function data() {
    return {
      searchItem: '',
      deleteItemId: null,
      deletePrompt: false,
      accounts: [],
      selectedAccounts: [],
      selectedAccount: null,
      createForAccount: null,
      consumers: [],
      bridgeTypes: [],
      consumerModel: cloneDeep(emptyModel),
      newChainItemType: null,
      isCreateDialog: true,
      tableOptions: defaultTableOptions,
      dialogFormValid: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('authentication', ['tenantId'])), {}, {
    hasNoChains: function hasNoChains() {
      return this.consumers.length === 0;
    },
    triggerSources: function triggerSources() {
      return [{
        value: 'stateIngest',
        text: 'BEFORE STATE-HANDLING'
      }, {
        value: 'influxdbDataPoint',
        text: 'AFTER STATE-HANDLING'
      }, {
        value: 'alarmLogEntry',
        text: 'ALARM-LOG WAS CREATED/RESOLVED'
      }];
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Bridges.Consumers.chains.trigger'),
          value: 'triggerType',
          align: 'start'
        }, {
          text: this.$i18n_t('Bridges.Consumers.chains.steps'),
          sortable: true,
          value: 'steps',
          align: 'start'
        }, {
          text: this.$i18n_t('accMgmt.tenant.bridges.title'),
          sortable: false,
          value: 'bridges',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.fetchTenantData();
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  methods: {
    fetchTenantData: function () {
      var _fetchTenantData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var ids;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;

                if (!this.selectedAccounts) {
                  this.selectedAccounts = [];
                }

                ids = this.selectedAccounts.map(function (acc) {
                  return acc.id;
                });
                _context.t0 = Promise;
                _context.next = 6;
                return ApiService.consumersFetch(ids);

              case 6:
                _context.t1 = _context.sent;

                if (!this.bridgeTypes.length) {
                  _context.next = 11;
                  break;
                }

                _context.t2 = Promise.resolve(this.bridgeTypes);
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return ApiService.getBridgeTypes();

              case 13:
                _context.t2 = _context.sent;

              case 14:
                _context.t3 = _context.t2;
                _context.t4 = [_context.t1, _context.t3];

                _context.t0.all.call(_context.t0, _context.t4).then(function (data) {
                  _this.bridgeTypes = data[1];
                  _this.consumers = data[0].map(function (c) {
                    c.bridges = c.bridges.map(function (b) {
                      var bridgeType = _this.bridgeTypes.find(function (t) {
                        return t.type === b.type;
                      });

                      b.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
                      return b;
                    });
                    return _objectSpread(_objectSpread({}, c), {}, {
                      steps: c.chain.length
                    });
                  });
                }).catch(function (error) {
                  console.error(error);
                }).finally(function () {
                  _this.isLoading = false;
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTenantData() {
        return _fetchTenantData.apply(this, arguments);
      }

      return fetchTenantData;
    }(),
    openEditModal: function openEditModal() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.consumerModel = cloneDeep(item || emptyModel);
      this.formDialogOpen = true;

      if (item === null) {
        this.selectedAccount = null;
        this.isCreateDialog = true;
      } else {
        this.isCreateDialog = false;
        this.selectedAccount = this.accounts.find(function (acc) {
          return acc.id === item.tenantId;
        });
      }
    },
    save: function save() {
      var _this2 = this;

      var accountId = get(this, '$refs.chainsEdit.account.id');
      var promise = null;

      if (this.consumerModel.id) {
        promise = ApiService.consumersUpdate(this.consumerModel.id, this.consumerModel);
      } else {
        promise = ApiService.consumersCreate(accountId, this.consumerModel);
      }

      promise.then(function () {
        _this2.fetchTenantData();

        _this2.closeDialog();
      }).catch(function (e) {
        _this2.$snack(e.response.data.message, 'error');
      });
    },
    showDeletePrompt: function showDeletePrompt(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    deleteConsumer: function deleteConsumer(id) {
      var _this3 = this;

      ApiService.consumersDelete(id).then(function () {
        _this3.fetchTenantData();
      }).catch(function (e) {
        _this3.$snack(e.response.data.message, 'error');
      }).finally(function () {
        _this3.deletePrompt = false;
      });
    },
    fetchAccounts: function fetchAccounts() {
      var _this4 = this;

      this.isLoading = true;
      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this4.accounts = accounts;

        _this4.fetchTenantData();
      }).catch(function (error) {
        console.error(error);

        _this4.$snack(_this4.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        _this4.isLoading = false;
      });
    }
  }
};